import { Directive, HostListener, Input } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';
import { SelectEvent } from '@progress/kendo-angular-upload';
import { Constants } from 'src/app/shared/constants/constants';

@Directive({
    selector: '[appFileRestrictions]',
    standalone: false
})
export class FileRestrictionsDirective {
  @Input() allowedExtensions: string[] = Constants.uploadFileTypeAllowed;
  @Input() minFileSize: number = Constants.minFileuploadSize; // Default 1KB
  @Input() maxFileSize: number = Constants.maxFileuploadSize; // Default 28MB

  constructor(private notificationService: NotificationService) {}

  @HostListener('select', ['$event'])
  fileSelectHandler(event: SelectEvent): boolean {
    let fileRestricted: boolean = false;
    for (const file of event.files) {
      const fileExtension: string = file.extension.toLowerCase();
      if (!this.allowedExtensions.includes(fileExtension)) {
        this.showNotification(
          `Allowed file types: ${this.allowedExtensions.join(', ')}`,
          'error'
        );
        fileRestricted = true;
        event.preventDefault();
        break;
      }
      if (
        this.allowedExtensions.includes(fileExtension) &&
        (file.size < this.minFileSize || file.size > this.maxFileSize)
      ) {
        this.showNotification('File Size accepted is between 1 KB to 28 MB', 'error');
        event.preventDefault();
        fileRestricted = true;
        break;
      }
    }
    return fileRestricted;
  }

  private showNotification(content: string, notificationType: 'error' | 'success' | 'warning' | 'info' | 'none'): void {
    this.notificationService.show({
      content: content,
      position: { horizontal: 'center', vertical: 'top' },
      animation: { type: 'fade', duration: 1200 },
      type: { style: notificationType, icon: true },
    });
  }
}
